import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@shared/general/translation/constants/translation.constant";

export const newsRoutes: Routes = [
  {
    path: "",
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.NEWS.ARTICLE),
    },
    loadChildren: () => import("./domains/article/article.routes").then(m => m.articleRoutes),
  },
];
